/* @flow */	
/* @jsx jsxDom */	
/* eslint max-lines: 0 */
import { getContainerStyle, getSandboxStyle } from './containerStyle';


// eslint-disable-next-line no-unused-vars
export function containerTemplate({ id, props, CLASS, ANIMATION, CONTEXT, EVENT, on, tag, context, actions, outlet, jsxDom }){

    //let [ lang ] = props.locale

    function close(event) {
        event.preventDefault();
        event.stopPropagation();
        actions.close();
    }

    function focus(event) {
        event.preventDefault();
        event.stopPropagation();
        actions.focus();
    }

    let style = props.style || {};
    let overlayColor = style.overlayColor || 'black';
    let logoColor = 'white';

    let el = (
        <div id={ id } onClick={ focus } class={ `${ tag }-context-${ context } easyscale-checkout-overlay ${ tag }-background-color-${ overlayColor } ${ tag }-logo-color-${ logoColor }` }>
            <div class="easyscale-checkout-close" onClick={ close } aria-label="close" role="button"></div>

            <div class="easyscale-checkout-iframe-container">
                {outlet}
            </div>

            <style>{getContainerStyle({ id, tag, CONTEXT, CLASS, ANIMATION })}</style>
        </div>
    );

    let container = (
        <html>
            <body>
                { el }
            </body>
        </html>
    );

    on(EVENT.CLOSE, () => {
        el.className += ` ${ tag }-loading`;
    });

    return (
        <div id={ id } class="easyscale-checkout-sandbox">
            <style>{ getSandboxStyle({ id, ANIMATION }) }</style>

            <div class="easyscale-checkout-sandbox-iframe">
                { container }
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/zoid/popup/containerTemplate.jsx